<template>
    <div class="row">
            <div class="col-12 margin">
                <!-- PERFIL - DOCUMENTOS -->
                <section class="no-space">
                    <div class="tit">
                        <h2 class="space">Documentos</h2>
                    </div>
                </section>

                <section class="small-space">
                    <h3>Contratos</h3>
                    <div class="row docs">
                        <div class="col-12 col-md-6" >
                            <a class="btn btn-link d-flex justify-content-start align-items-center" :href="siteEndPoint+'/termos/'" target="_blank">
                                <i class="icon icon-pdf-3 xll"></i>
                                <span>Termos e condições gerais de uso</span>
                            </a>
                        </div>

                        <div class="col-12 col-md-6" >
                            <a class="btn btn-link d-flex justify-content-start align-items-center" :href="siteEndPoint+'/politica-de-privacidade/'" target="_blank">
                                <i class="icon icon-pdf-3 xll"></i>
                                <span>Políticas de privacidade</span>
                            </a>
                        </div>
                    </div>
                </section>
                <section>
                    <div class="row" >
                        <div class="col sub-tit">
                            <h3>Documentos envidados por você<a v-if="mostraDocsEnviados()" href="javascript:;" class="reenviar" @click="documentos()">Reenviar Documentos</a></h3>
                        </div>
                    </div>
                    
                    <div class="row docs d-flex justify-content-center align-items-center">
                        <div class="col-12 col-lg-6 col-xl-4" v-for="item in this.investidores.ArquivosIdentidade" style="margin-bottom: 10px;">
                            <div class="box-doc">
                                <i class="icon icon-jpg-2 lg"></i>
                                <div class="doc-text">
                                    <h5>
                                        Documento de Identidade
                                    </h5>
                                    <p>Arquivo: <span> {{nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)}}</span> </p>
                                    <div class="d-flex justify-content-start align-items-center">
                                        <p>
                                            
                                            Enviado em {{formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)}}
                                        </p>
                                        <a :href="hubEndPoint+'/file/'+item.Nome" target="_blank">
                                            Visualizar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4" v-for="item in this.investidores.ArquivosComprovanteResidencia" style="margin-bottom: 10px;">
                            <div class="box-doc">
                                <i class="icon icon-jpg-2 lg"></i>
                                <div class="doc-text">
                                    <h5>
                                        Comprovante de residência
                                    </h5>
                                     <p>Arquivo: <span> {{nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)}}</span> </p>
                                    <div class="d-flex justify-content-start align-items-center">
                                        <p>Enviado em {{formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)}}</p>
                                        <a :href="hubEndPoint+'/file/'+item.Nome" target="_blank">
                                            Visualizar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4" v-for="item in this.investidores.ExtratoBancario" style="margin-bottom: 10px;">
                            <div class="box-doc">
                                <i class="icon icon-jpg-2 lg"></i>
                                <div class="doc-text">
                                    <h5>
                                        Extrato bancario
                                    </h5>
                                     <p>Arquivo: <span> {{nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)}}</span> </p>
                                    <div class="d-flex justify-content-start align-items-center">
                                        <p>Enviado em {{formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)}}</p>
                                        <a :href="hubEndPoint+'/file/'+item.Nome" target="_blank">
                                            Visualizar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row docs justify-content-center align-items-center">
                        <div class="col-12 col-lg-6 col-xl-4" v-for="item in this.investidores.ImpostoRenda" style="margin-bottom: 10px;">
                            <div class="box-doc">
                                <i class="icon icon-jpg-2 lg"></i>
                                <div class="doc-text">
                                    <h5>
                                        Imposto de Renda
                                    </h5>
                                     <p>Arquivo: <span> {{nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)}}</span> </p>
                                    <div class="d-flex justify-content-start align-items-center">
                                        <p>Enviado em {{formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)}}</p>
                                        <a :href="item.UrlTemporario">
                                            Visualizar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4" v-for="item in this.investidores.ContratoSocial" style="margin-bottom: 10px;">
                            <div class="box-doc">
                                <i class="icon icon-jpg-2 lg"></i>
                                <div class="doc-text">
                                    <h5>
                                        Contrato social
                                    </h5>
                                     <p>Arquivo: <span> {{nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)}}</span> </p>
                                    <div class="d-flex justify-content-start align-items-center">
                                        <p>Enviado em {{formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)}}</p>
                                        <a :href="item.UrlTemporario">
                                            Visualizar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4" v-for="item in this.investidores.Dre" style="margin-bottom: 10px;">
                            <div class="box-doc">
                                <i class="icon icon-jpg-2 lg"></i>
                                <div class="doc-text">
                                    <h5>
                                        DRE 
                                    </h5>
                                     <p>Arquivo: <span> {{nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)}}</span> </p>
                                    <div class="d-flex justify-content-start align-items-center">
                                        <p>Enviado em {{formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)}}</p>
                                        <a :href="item.UrlTemporario">
                                            Visualizar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- :::::::::::::::: -->
            </div>
        </div>
    </div>
</template>

<style lang="css">
    .reenviar {
        font-size: 0.875rem; 
        font-weight: normal; 
        text-decoration: underline !important; 
        color: #888888 !important;
        margin-left: 5px;
    }

    .reenviar:hover {
        text-decoration: none !important;
    }
</style>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/mixins";

    .margin {
        @include ds {
            padding-left: 15px;
        }
        @include dl {
            padding-left: 30px;
        }
    }

</style>


<script>
import ApiClient from "@/utils/api-client";
import * as mutationTypes from "@/store/mutation-types.js";

export default {
    data() {
        return {
            investidores: {},
            /* eslint-disable */
            hubEndPoint: process.env.HUB_URL,
            siteEndPoint: process.env.LP_URL,
            url: '/static/termos/',
            docLinks : [
                {
                    "name": "Termos e condições gerais de uso",
                    "link": "Termos_e_Condicoes.pdf" 
                },
                {
                    "name": "Políticas de privacidade",
                    "link": "Politica_de_Privacidade.pdf"
                }
            ]
        };
    },
    methods : {
        formatDate(data) {
           let dataForm = new Date(data);
            let dia = dataForm.getDate();
            if (dia.toString().length == 1)
            dia = "0"+dia;
            let mes = dataForm.getMonth()+1;
            if (mes.toString().length == 1)
            mes = "0"+mes;
            let ano = dataForm.getFullYear();
            return dia+"/"+mes+"/"+ano; 
        },
        documentos() {
            this.$router.push('../documentos?type=INV&id=' + this.$store.state.currentUser.investor._id);
        },
        mostraDocsEnviados(){
            
            return  ((this.investidores.Dre != undefined && this.investidores.Dre.length > 0)  ||
                    (this.investidores.ContratoSocial != undefined && this.investidores.ContratoSocial.length > 0)  ||
                    (this.investidores.ImpostoRenda != undefined && this.investidores.ImpostoRenda.length > 0)  ||
                    (this.investidores.ExtratoBancario != undefined && this.investidores.ExtratoBancario.length > 0)  ||
                    (this.investidores.ArquivosComprovanteResidencia != undefined && this.investidores.ArquivosComprovanteResidencia.length  > 0)  ||
                    (this.investidores.ArquivosIdentidade != undefined && this.investidores.ArquivosIdentidade.length > 0)) && 
                    (this.investidores.StatusDocumentos != "APROVADO");
        },
        removerArquivosInvisiveis(itens){
            var retorno;
            if(Array.isArray(itens)){
               retorno = itens.filter((item=>{
                   return item.Exibir != false;
                }))

                return retorno;
            }

            return {};
        },
            
        nomeArquivo(arquivo){
            if(arquivo.length > 22){
                var extensao = arquivo.substr(arquivo.lastIndexOf("."))
                var nome = arquivo.substr(0,arquivo.lastIndexOf("."))

                return nome.substr(0,15)+"..." + extensao;

            }

            return arquivo;
        },

        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: 'perfil/documentos',
                title: 'Documentos',
            })
        },
    },
    async beforeCreate() {
        this.$store.commit(mutationTypes.START_LOADING);
        await ApiClient.getInvestor()
         .then(investor =>{
            this.investidores = investor;

            this.investidores.Dre = this.investidores.Dre || {};


            this.investidores.ContratoSocial = this.removerArquivosInvisiveis(this.investidores.ContratoSocial);
            this.investidores.ImpostoRenda = this.removerArquivosInvisiveis(this.investidores.ImpostoRenda);
            this.investidores.ExtratoBancario = this.removerArquivosInvisiveis(this.investidores.ExtratoBancario);
            this.investidores.ArquivosComprovanteResidencia = this.removerArquivosInvisiveis(this.investidores.ArquivosComprovanteResidencia);
            this.investidores.ArquivosIdentidade = this.removerArquivosInvisiveis(this.investidores.ArquivosIdentidade);


             this.$store.commit(mutationTypes.STOP_LOADING);
         })
         .catch(() => this.$store.commit(mutationTypes.STOP_LOADING));
    },

    async created() {
        //tagueamento GA
        await this.taggingGA();
    }

}
</script>



// WEBPACK FOOTER //
// src/views/ProfileDocs.vue